import React from 'react'
import { AddLocationIcon, FlexContainer, Text } from '@busie/ui-kit'

interface Props {
  onClick: () => void
}

const EnterLocation: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
}) => {
  return (
    <FlexContainer
      w="100%"
      pl={2}
      pr={2}
      align="center"
      columnGap={1.5}
      pt={1.5}
      sx={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      <FlexContainer w="20px" justify="center" align="center">
        <AddLocationIcon />
      </FlexContainer>
      <Text color="#0F5FD7" weight={500}>
        Add location
      </Text>
    </FlexContainer>
  )
}

export default EnterLocation
